// extracted by mini-css-extract-plugin
export default {"leftNav":"gallery-overlay_leftNav__Tq7-l","rightNav":"gallery-overlay_rightNav__sbVdL","overlay":"gallery-overlay_overlay__RI1wl"};